<script lang="ts">
    export let tag: string;
    export let text: string;
</script>

<br>

<h2 id={tag}>{text}</h2>

<style>
</style>